import { useQuery } from '@tanstack/react-query';

import { contactsAPI, contactsEndpoints } from '@/api/contacts';

export const useContactAsOf = (contactId: string, at: string) => {
  const { data, status } = useQuery({
    queryKey: [contactsEndpoints.asOf(contactId, at)],
    queryFn: () => contactsAPI.getContactAsOf(contactId, at),
  });

  return { asOf: data, status };
};
